export const INTEGRATION_KEY_PREFIX = 'INTEGRATION_KEY_V1_'

export const INTEGRATION_KEY = {
  /** dev override — iframe 띄울 origin (08-1). */
  IFRAME_TARGET_DOMAIN: `${INTEGRATION_KEY_PREFIX}IFRAME_TARGET_DOMAIN`,
  /** dev 에서 자기 origin 의 sender/receiver 역할을 강제. 값: `'sender' | 'receiver'`. */
  DEV_FORCE_ROLE: `${INTEGRATION_KEY_PREFIX}DEV_FORCE_ROLE`,

  /** receiver 측 마이그레이션 완료 marker. */
  MIGRATION_DONE: `${INTEGRATION_KEY_PREFIX}MIGRATION_DONE`,
  /** sender 측 이관 완료 marker. */
  TRANSFERRED: `${INTEGRATION_KEY_PREFIX}TRANSFERRED`,
  /** mathflat-student 분리 키 → 'scoring' Map 마이그레이션 완료된 legacyKeyPrefix 목록. 값: JSON.stringify(string[]). */
  SCORING_MIGRATION_DONE: `${INTEGRATION_KEY_PREFIX}SCORING_MIGRATION_DONE`,
} as const

/** 마커 / flag sentinel 값. */
export const INTEGRATION_VALUE = {
  /** 단순 존재 여부 marker (MIGRATION_DONE / TRANSFERRED) */
  TRUE: 'true',
  /** DEV_FORCE_ROLE — sender 강제. hostname 자동 매칭을 덮어씀. */
  ROLE_SENDER: 'sender',
  /** DEV_FORCE_ROLE — receiver 강제. hostname 자동 매칭을 덮어씀. */
  ROLE_RECEIVER: 'receiver',
} as const

/** DEV_FORCE_ROLE 의 정상 값 union — 다른 임의 string 은 무시 (auto 로 fallback). */
export type DevForceRole =
  | typeof INTEGRATION_VALUE.ROLE_SENDER
  | typeof INTEGRATION_VALUE.ROLE_RECEIVER

/** 라이브 외 + hostname 매칭 실패 시의 sender→receiver iframe origin fallback (dev only). */
export const DEV_DEFAULT_PEER_ORIGIN = 'https://student-up-dev.mathflat.com'

// ─────────────────────────────────────────────────────────────────────────────
// postMessage wire — sender ↔ receiver iframe + redirect probe + BroadcastChannel publish.
// ─────────────────────────────────────────────────────────────────────────────
const MSG_PREFIX = 'INTEGRATION_MSG_V1_'

export const INTEGRATION_MESSAGE_TYPE = {
  REQUEST_SYNC: `${MSG_PREFIX}REQUEST_SYNC`,
  SYNC_SUCCESS: `${MSG_PREFIX}SYNC_SUCCESS`,
  SYNC_EMPTY: `${MSG_PREFIX}SYNC_EMPTY`,
  SYNC_COMPLETED: `${MSG_PREFIX}SYNC_COMPLETED`,

  PROBE_RESPONSE: `${MSG_PREFIX}PROBE_RESPONSE`,
  /** BroadcastChannel publish 전용 — 다탭 student-up redirect 동기 */
  BC_REDIRECT_TO_STUDENT: `${MSG_PREFIX}REDIRECT_TO_STUDENT`,
  /** 명시 로그아웃 cross-origin 정리 — receiver↔sender 한쪽이 iframe 으로 띄워 반대 origin 의 storage clear */
  LOGOUT_CLEAR: `${MSG_PREFIX}LOGOUT_CLEAR`,
  /** LOGOUT_CLEAR 처리 완료 — sender 가 iframe 안에서 storage clear 마친 후 발신. */
  LOGOUT_CLEAR_ACK: `${MSG_PREFIX}LOGOUT_CLEAR_ACK`,

  /** dev panel 원격 reset ACK — sender 인라인이 TRANSFERRED marker 제거 후 발신 (라이브 외 한정). */
  DEV_RESET_DONE: `${MSG_PREFIX}DEV_RESET_DONE`,
} as const

// ─────────────────────────────────────────────────────────────────────────────
// BroadcastChannel — 다탭 동기.
// ─────────────────────────────────────────────────────────────────────────────
export const INTEGRATION_BC = {
  /** sender 의 SYNC_COMPLETED 처리 후 publish, useTransferDoneRedirect hook 이 subscribe. */
  CHANNEL: 'integration_v1_sync',
} as const
